import { z } from "zod";

import {
  FILE_ACCEPTED_TYPES,
  FILE_MAX_SIZE,
  FILE_SIZE_ERR_MSG,
  FILE_TYPE_ERR_MSG,
} from "~/v2/components/fileUpload";
import { zNonEmptyString } from "../../../entityOnboarding/util";

export const zWireSchema = z
  .object({
    isInternational: z.coerce.boolean(),
    name: zNonEmptyString,
    account_number: zNonEmptyString,
    bank_code: zNonEmptyString,
    bank_statement: z
      .instanceof(File)
      .refine((file) => !!file, "Bank statement is required.")
      .refine((file) => file.size <= FILE_MAX_SIZE, FILE_SIZE_ERR_MSG)
      .refine(
        (file) => FILE_ACCEPTED_TYPES.includes(file?.type),
        FILE_TYPE_ERR_MSG,
      ),

    // International Fields - optional
    bank_code_type: z.enum(["ABA", "BIC"]).optional(),
    country: z.string().optional(),
    state_province: z.string().optional(),
    postal_code: z.string().optional(),
    city: z.string().optional(),
    street_address: z.string().optional(),
    additional_information: z.string().optional(),
  })
  .superRefine(
    (
      {
        isInternational,
        bank_code_type,
        country,
        state_province,
        postal_code,
        city,
        street_address,
      },
      ctx,
    ) => {
      if (isInternational) {
        if (!bank_code_type) {
          ctx.addIssue({
            code: "custom",
            message: "Bank code type is required for international wires.",
            path: ["bank_code_type"],
          });
        }
        if (!country) {
          ctx.addIssue({
            code: "custom",
            message: "Country is required for international wires.",
            path: ["country"],
          });
        }
        if (!state_province) {
          ctx.addIssue({
            code: "custom",
            message: "State/Province is required for international wires.",
            path: ["state_province"],
          });
        }
        if (!postal_code) {
          ctx.addIssue({
            code: "custom",
            message: "Postal code is required for international wires.",
            path: ["postal_code"],
          });
        }
        if (!city) {
          ctx.addIssue({
            code: "custom",
            message: "City is required for international wires.",
            path: ["city"],
          });
        }
        if (!street_address) {
          ctx.addIssue({
            code: "custom",
            message: "Street address is required for international wires.",
            path: ["street_address"],
          });
        }
      }
    },
  );

export type WireSchema = z.infer<typeof zWireSchema>;
